<template>
<div class="container-fluid">
    <div class="login-container">
		<div class="card login-card shadow border border-white p-5 m-5 bg-white">
			<b-col class="text-center">
				<img src="@/assets/images/mainLogo.png" alt="Main Logo" class="img-fluid mx-auto d-block" />
			</b-col>
			<br><br>
			<b-col class="text-center mb-5">
				<strong class="m-3">Parent Login</strong>
			</b-col>
			<b-col>
				<!-- Email Input -->
				<b-form-group id="input-group-1" label-for="input-1">
					<label class="required-label">Email:</label>
					<b-form-input id="input-1" type="email" v-model="email" placeholder="Enter Email"
						:disabled="emailExists"></b-form-input>
				</b-form-group>
	
				<!-- OTP Section -->
				<b-row style="justify-content: center;">
					<span v-if="loginStatus == 'senting'">Sending OTP...</span>
					<div v-else>
						<!-- Show Get OTP Button initially -->
						<b-button v-if="resentOTPcountDownLeft === 0 && loginStatus !== 'otp_sent'" class="btn-success"
							@click="sentOtp">
							Get OTP
						</b-button>

						<!-- Show timer while waiting to resend OTP -->
						<span v-if="resentOTPcountDownLeft > 0" class="text-info">
							You can resend OTP after {{ resentOTPcountDownLeft }} seconds
						</span>

						<!-- Show Resend OTP Button after countdown ends -->
						<b-button v-if="resentOTPcountDownLeft === 0 && loginStatus === 'otp_sent'" class="btn-success"
							@click="sentOtp">
							Resend OTP
						</b-button>
					</div>
				</b-row>

				<!-- OTP Input Field -->
				<div v-if="loginStatus == 'otp_sent'">
					<b-form-group>
						<label class="required-label">OTP:</label>
						<b-form-input v-model="otp" type="text" placeholder="Enter OTP"></b-form-input>
					</b-form-group>

					<!-- Login Button (Always show when OTP is entered) -->
					<b-row style="justify-content: center;">
						<b-button :disabled="otp === ''" @click="parentLogin"
							class="btn-success shadow-sm">Login</b-button>
					</b-row>
				</div>

			</b-col>
		</div>
		<!-- Back to Main Login Button Outside the Card -->
		<div class="text-center">
			<b-button
				class="border-white text-white rounded-pill py-2 px-4"
				style="border: 2px solid white; background-color: transparent; text-transform: uppercase;"
				@click="backToMainLogin">
				Back to Main Log in
			</b-button>
		</div>
	</div>
</div>
</template>

<script>
export default {
	data() {
		return {
			resentOTPcountDownLeft: 0,
			countdownInterval: null,
			email: '',
			password: '',
			otp: '',
			loginStatus: '',
		};
	},
	created() {
		this.email = this.$route.params.email ?? '';
		const parentAuthToken = localStorage.getItem("parentAuthToken");

		if (parentAuthToken) {
			this.$router.push('/parentuser/dashboard');
		} else {
			if (this.$route.params.parentemail) {
				this.$router.push({ name: 'parentMainLogin', params: { parentemail: this.$route.params.parentemail } });
			}
			else {
				this.$router.push('/parentuser/login');
			}
		}
	},
	methods: {
		backToMainLogin(){
			this.$router.push("/");
		},
		
		async parentLogin() {
			const url = `${this.$store.getters.getAPIKey.mainAPI}/parentuser/login/with_otp`;
			let token = null;
			await this.$axios
				.post(url, { email: this.email, otp: this.otp })
				.then((response) => {
					token = response.data.parent_auth_token;
				})
				.catch((error) => {
					const errortxt = error.response?.data?.error ?? 'Failed to Login, please try again';
					this.$toast.error(errortxt, { position: "top", duration: 7000 });
				});
			if (token) {
				localStorage.setItem("parentAuthToken", token);
				localStorage.setItem("parentAuthEmail", this.email);
				this.$router.push('/parentuser/dashboard');
			}
		},
		// Countdown Timer Logic
		resentOtpCountDown() {
			this.resentOTPcountDownLeft = 120;
			if (this.countdownInterval) {
				clearInterval(this.countdownInterval);
			}
			this.countdownInterval = setInterval(() => {
				if (this.resentOTPcountDownLeft > 0) {
					this.resentOTPcountDownLeft--;
				} else {
					clearInterval(this.countdownInterval);
					this.countdownInterval = null;
				}
			}, 1000);
		},

		async sentOtp() {
			this.loginStatus = 'senting';
			const url = `${this.$store.getters.getAPIKey.mainAPI}/parentuser/login/request_otp`;

			await this.$axios
				.post(url, { email: this.email })
				.then(() => {
					this.$toast.success('OTP sent successfully, please check your inbox.', {
						position: "top",
						duration: 4000,
					});
					this.resentOtpCountDown();
					this.loginStatus = 'otp_sent';
				})
				.catch((error) => {
					this.loginStatus = '';
					let errortxt = error.response?.data?.message ?? 'Failed to send OTP';
					this.$toast.error(errortxt, {
						position: "top",
						duration: 7000,
					});
				});
		}
	},
	beforeDestroy() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}
};
</script>

<style scoped>
button {
	border-radius: 10px;
}

.container-fluid {
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 15px;
	background: linear-gradient(90deg, rgb(150 219 255 / 58%) 0%, rgb(222 136 255 / 54%) 100%);
}

.login-card {
	width: 390px;
	background: #fff;
	border-radius: 10px;
	padding: 20px;
}
</style>
